/* eslint-disable */
export default {
  Set: 'SetAmount',
  Increase: 'IncreaseBudget',
  Decrease: 'DecreaseBudget'
};

